import React, { useState, useEffect } from "react";
import Navbar from "../Components/Navbar";
import HelpMessage from "../Components/HelpMessage";
import { useNavigate } from "react-router-dom";
import SearchBar from "../Components/SearchBar";
import axios from "axios";
import moment from "moment";

const Notes = () => {
  const navigate = useNavigate();
  const navigateToEditNotes = (noteID) => {
    const noteToEdit = data.find((item) => item.Id === noteID);
    if (noteToEdit) {
      navigate(`/Notes/EditNotes`, { state: { note: noteToEdit } });
    }
  };

  const [data, setData] = useState([]);
  const [noDataAvailable, setNoDataAvailable] = useState(false);
  const currentUser = localStorage.getItem("currentUser");

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Include the supplier ID in the API request
        const response = await axios.get(
          `${process.env.REACT_APP_API_BASEURL}/api/notes?supplier=${currentUser}`
        );
        const notesData = response.data;

        // Check if there's any data for the supplier
        if (notesData.length > 0) {
          setData(notesData);
        } else {
          setNoDataAvailable(true);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [currentUser]);
  return (
    <>
      <div className="container-login100">
        <div className="wrap-login100">
          <Navbar />
          <div className="tableft">
            <a>Notes</a>
          </div>
          <div className="" id="result-wrapper">
            <SearchBar />
            <form id="frmViewNotes" method="post">
              {noDataAvailable ? (
                <p>No Notes available for this Supplier.</p>
              ) : (
                <table className="tblViewNotes" id="resultdetail">
                  <thead>
                    <tr className="heading">
                      <td className="viewnotes_incident">Event</td>
                      <td className="viewnotes_date">Date</td>
                    </tr>
                  </thead>
                  <tbody>
                    {data.map((row, index) => (
                      <React.Fragment key={index}>
                        <tr className="trhide" id={`expand-${row.Id}`}
                          onClick={() => {
                            // Slide Toggle the tabletr- Row
                            const tabletr = document.getElementById(
                              `tabletr-${row.Id}`
                            );
                            const table = document.getElementById(
                              `table-${row.Id}`
                            );
                            if (tabletr.style.display === "none") {
                              tabletr.style.display = "table-row";
                              table.style.display = "table-cell";
                            } else {
                              tabletr.style.display = "none";
                              table.style.display = "none";
                            }
                          }}
                        >
                          <td className={row.Id % 2 === 0 ? "odd" : ""}>
                            {row.descript}
                          </td>
                          <td className={row.Id % 2 === 0 ? "odd" : ""}>
                            {moment(row.fdate).format("DD/MM/YYYY")}{" "}
                            &nbsp; &nbsp;
                            <i
                              className="fas fa-pen-square"
                              onClick={() => navigateToEditNotes(row.Id)} // Pass the ID
                              id={`Edit-${row.Id}`}
                              style={{
                                cursor: "pointer",
                              }}
                            />
                          </td>
                        </tr>
                        <tr
                          className="expandRowtr"
                          id={`tabletr-${row.Id}`}
                          style={{
                            display: "none",
                          }}
                        >
                          <td
                            className="table-expand"
                            colSpan="2"
                            style={{
                              borderLeft: "6px solid #e87320",
                              padding: '16px',
                            }}
                            id={`table-${row.Id}`}>
                              {row.notes1}
                            </td>
                        </tr>
                      </React.Fragment>
                    ))}
                  </tbody>
                </table>
              )}
              <div className="add-btn-wrap">
                <button
                  onClick={() => {
                    navigate("/Notes/AddNotes");
                  }}
                  className="btn btn-lg btn-primary"
                  style={{
                    marginTop: "30px",
                  }}
                  type="button"
                >
                  <span className="glyphicon glyphicon-plus" />
                  &nbsp;
                  <span>ADD LISTING</span>
                </button>
              </div>
              <HelpMessage />
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default Notes;
